<div class="detail-container">
  <form name="recipientEntityForm" #recipientEntityForm="ngForm">
    <div class="section container-fluid col-md-11 justify-content-center" fxLayoutGap="grid">
      <div class="innertitletxt">
        Société destinataire
      </div>
      <div class="card">
        <div class="card-body">
          <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
            <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
              <div fxFlex="50" fxFlex.gt-sm="50">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Nom </mat-label>
                  <input matInput [(ngModel)]="recipientEntity.Name" name="Name" type="text" [disabled]="recipientEntity.Id">
                </mat-form-field>
              </div>
              <div fxFlex="25" fxFlex.gt-sm="25">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Actif</mat-label>
                  <input matInput readonly hidden>
                  <mat-slide-toggle [(ngModel)]="recipientEntity.IsActive" name="IsActive" [disabled]="recipientEntity.Id && !recipientEntity.CanBeDisabled" tooltip="Activer/Désactiver la société"
                    class="customToggle">
                  </mat-slide-toggle>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
              <div fxFlex="33" fxFlex.gt-sm="33" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Groupe opérationnel </mat-label>
                  <input matInput readonly hidden>
                  <ng-multiselect-dropdown (onSelect)="onSelectOperationalGroup($event,'select')" (onDeSelect)="onSelectOperationalGroup($event,'deselect')"
                    [settings]="singleSelectionDropDownSettings" name="selectedItemsOperationalGroups" (onFilterChange)="onGroupFilterChange(2, $event)" [data]="operationalGroups"
                    [(ngModel)]="selectedItemsOperationalGroups">
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="33" fxFlex.gt-sm="33" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Groupe de supervision </mat-label>
                  <input matInput readonly hidden>
                  <ng-multiselect-dropdown (onSelect)="onSelectSupervisionGroup($event,'select')" (onDeSelect)="onSelectSupervisionGroup($event,'deselect')"
                    [settings]="singleSelectionDropDownSettings" name="selectedItemsSupervisionGroups" (onFilterChange)="onGroupFilterChange(3, $event)" [data]="supervisionGroups"
                    [(ngModel)]="selectedItemsSupervisionGroups">
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="33" fxFlex.gt-sm="33" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Groupe de consultation </mat-label>
                  <input matInput readonly disabled hidden>
                  <ng-multiselect-dropdown (onSelect)="onSelectObservationGroup($event,'select')" (onDeSelect)="onSelectObservationGroup($event,'deselect')"
                    [settings]="singleSelectionDropDownSettings" name="selectedItemsObservationGroups" (onFilterChange)="onGroupFilterChange(8, $event)" [data]="consultationGroups"
                    [(ngModel)]="selectedItemsObservationGroups">
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div fxLayout=”row” fxLayoutAlign="end" class="bottom-bar">
      <div fxLayout=”row” fxLayoutAlign="end">
        <div class="btnSpacerCol">
          <button mat-stroked-button class="currentBtn" matTooltip="Annuler" (click)="onCancel()">
            <mat-icon>cancel</mat-icon>
            <span class="long-btn-span" fxHide fxShow.gt-md>Annuler</span>
          </button>
        </div>
        <div class="btnSpacerCol">
          <button mat-stroked-button class="currentBtnColor" matTooltip="Enregistrer" (click)="onSave()" [disabled]="recipientEntityForm.form.invalid">
            <mat-icon>save</mat-icon>
            <span class="long-btn-span" fxHide fxShow.gt-md>Enregistrer</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>